import type { AcmSdkConfig } from '@dce-front/sdk-acm';
import { createContext } from 'react';

export const AcmSdkContext = createContext<AcmSdkConfig | null>(null);
